import { rate, rating } from "openskill";

export function recalcScorecardsForTournament(tournament) {
  const inactiveMatches = [...tournament.inactiveMatches].sort((a, b) => a.createdAt.toMillis() - b.createdAt.toMillis());

  const playerRatings = {};
  for (const player of tournament.players) {
    playerRatings[player.id] = {
      mu: player.startOfTournamentMu,
      sigma: player.startOfTournamentSigma
    };
  }

  for (const match of inactiveMatches) {
    const teamRatings = [];
    const ranks = [];
    const maxGoals = Math.max(...match.teams.map(t => t.goals));

    for (const team of match.teams) {
      teamRatings.push(team.playerIds.map(pid => rating(playerRatings[pid])));
      ranks.push(team.goals === maxGoals ? 1 : 2);
    }

    const newRatings = rate(teamRatings, { rank: ranks });

    let ti = 0;
    for (const team of match.teams) {
      team.playerIds.forEach((pid, pi) => {
        playerRatings[pid].mu = newRatings[ti][pi].mu;
        playerRatings[pid].sigma = newRatings[ti][pi].sigma;
      });
      ti++;
    }
  }

  return playerRatings;
}